module.exports = __webpack_public_path__ + "static/media/3-Rakha.d052858b.webp";